import { render, staticRenderFns } from "./Birthday.vue?vue&type=template&id=8c6fa6f2&scoped=true&"
import script from "./Birthday.vue?vue&type=script&lang=js&"
export * from "./Birthday.vue?vue&type=script&lang=js&"
import style0 from "./Birthday.vue?vue&type=style&index=0&id=8c6fa6f2&scoped=true&lang=css&"
import style1 from "./Birthday.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6fa6f2",
  null
  
)

export default component.exports